import React from 'react';
import { Trans } from 'react-i18next';
import { FaLightbulb } from 'react-icons/fa';
import styled from 'styled-components';

export const SpreadsheetUsage: React.FC = () => (
  <Horizontal className="hint spreadsheet-usage">
    <FaLightbulb />
    <div>
      <Trans i18nKey="ui.subscription.datasheetUsageManual">
        <a
          href="https://globis4biz.zendesk.com/hc/ja/articles/21832021826073"
          target="_blank"
          rel="noopener noreferrer"
        ></a>
      </Trans>
    </div>
  </Horizontal>
);

const Horizontal = styled.div`
  &.spreadsheet-usage {
    display: flex;
    gap: 3.5px;
  }
`;
